<template>
  <div>
    <MainHeader />
    <v-container>
      <v-row>
        <v-col
          class="mt-4"
          cols="12"
        >
          <CardSafeguardingSummary
            :loading="loading"
            :summary-data="summaryData"
            :license="$route.params.license"
            @page-loading="onPageLoading"
          />
        </v-col>
      </v-row>

      <v-overlay :value="pageLoading">
        <VProgressCircular
          indeterminate
          size="64"
        />
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import MainHeader from "@/components/MainHeader";
import SafeguardingService from "@/services/SafeguardingService";
import CardSafeguardingSummary from "@/components/safeguarding/CardSafeguardingSummary";

export default {
  name: "SafeguardingV2",
  components: {
    MainHeader,
    CardSafeguardingSummary
  },
  data() {
    return {
      loading: false,
      summaryData: null,
      pageLoading: false
    };
  },
  mounted() {
    this.getUnifiedSummary();
  },
  methods: {
    onPageLoading(value) {
      this.pageLoading = value;
    },
    getUnifiedSummary() {
      this.loading = true;
      const license = this.$route.params.license;
      console.log("V2 safeguarding license param:", license);
      SafeguardingService.getUnifiedSummary({
        license
      })
        .then(res => {
          this.summaryData = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
